const config = {
  development: {
    apiBaseUrl: "https://api.yakutbonus.xyz/api/advanced/",
    apiBaseUrl2: `https://api.yakutbonus.xyz/api`,
    adminApi: 'https://api.yakutbonus.xyz/admin/api',
    appName: "OrisBetBonus",
    imgUrl: "https://dev-test.hookapps.xyz",
  },
  production: {
    apiBaseUrl: `https://api.${window.location.hostname}/api/advanced/`,
    apiBaseUrl2: `https://api.${window.location.hostname}/api`,
    adminApi: `https://api.${window.location.hostname}/admin/api`,
    appName: "HookBonus",
    imgUrl: "",
  },
};

const env = "production";
export default config[env];
